var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/shop_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.3596 8.27L22.0696 5.5C21.6496 2.48 20.2796 1.25 17.3497 1.25H14.9896H13.5097H10.4697H8.98965H6.58965C3.64965 1.25 2.28965 2.48 1.85965 5.53L1.58965 8.28C1.48965 9.35 1.77965 10.39 2.40965 11.2C3.16965 12.19 4.33965 12.75 5.63965 12.75C6.89965 12.75 8.10965 12.12 8.86965 11.11C9.54965 12.12 10.7097 12.75 11.9997 12.75C13.2896 12.75 14.4197 12.15 15.1096 11.15C15.8797 12.14 17.0696 12.75 18.3096 12.75C19.6396 12.75 20.8396 12.16 21.5896 11.12C22.1896 10.32 22.4597 9.31 22.3596 8.27Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3501 16.66C10.0801 16.79 9.12012 17.87 9.12012 19.15V21.89C9.12012 22.16 9.34012 22.38 9.61012 22.38H14.3801C14.6501 22.38 14.8701 22.16 14.8701 21.89V19.5C14.8801 17.41 13.6501 16.42 11.3501 16.66Z",
    fill: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.3699 14.4001V17.3801C21.3699 20.1401 19.1299 22.3801 16.3699 22.3801C16.0999 22.3801 15.8799 22.1601 15.8799 21.8901V19.5001C15.8799 18.2201 15.4899 17.2201 14.7299 16.5401C14.0599 15.9301 13.1499 15.6301 12.0199 15.6301C11.7699 15.6301 11.5199 15.6401 11.2499 15.6701C9.46988 15.8501 8.11988 17.3501 8.11988 19.1501V21.8901C8.11988 22.1601 7.89988 22.3801 7.62988 22.3801C4.86988 22.3801 2.62988 20.1401 2.62988 17.3801V14.4201C2.62988 13.7201 3.31988 13.2501 3.96988 13.4801C4.23988 13.5701 4.50988 13.6401 4.78988 13.6801C4.90988 13.7001 5.03988 13.7201 5.15988 13.7201C5.31988 13.7401 5.47988 13.7501 5.63988 13.7501C6.79988 13.7501 7.93988 13.3201 8.83988 12.5801C9.69988 13.3201 10.8199 13.7501 11.9999 13.7501C13.1899 13.7501 14.2899 13.3401 15.1499 12.6001C16.0499 13.3301 17.1699 13.7501 18.3099 13.7501C18.4899 13.7501 18.6699 13.7401 18.8399 13.7201C18.9599 13.7101 19.0699 13.7001 19.1799 13.6801C19.4899 13.6401 19.7699 13.5501 20.0499 13.4601C20.6999 13.2401 21.3699 13.7201 21.3699 14.4001Z",
    fill: "#A8A8A8"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.a90e1bbf9efeac39c511e63964f970fb.svg";
export { ForwardRef as ReactComponent };